import { render, staticRenderFns } from "./ModalQuitarPublicidad.vue?vue&type=template&id=afff81de"
import script from "./ModalQuitarPublicidad.vue?vue&type=script&lang=js"
export * from "./ModalQuitarPublicidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports